<section class="cmn-innerpage-wrapper">
  <div class="inner-content settings-page" *ngIf="!loading">
    <div class="head">
      <div class="left-set">
        <h2 class="cmn-inner-heading">Settings</h2>
        <p>Manage usage limits and feature toggles</p>
      </div>
    </div>

    <div class="settings-section">
      <div class="section-header">

        <div class="section-title">
          <h3>Usage Settings</h3>
          <p>Configure usage limits per plan and feature</p>
        </div>
      </div>

      <!-- Create Form -->
      <ng-container *appHasPermission="'ADD_SETTINGS'">
      <div class="create-form-wrapper" *ngIf="availablePlans.length > 0">
        <div class="form-card">
          <div class="form-card-header">
            <mat-icon class="form-icon">add_circle_outline</mat-icon>
            <div>
              <h4>Add New Setting</h4>
              <p *ngIf="settings.length === 0">No usage settings configured yet. Create one to get started.</p>
              <p *ngIf="settings.length > 0">Each plan can have up to 3 feature settings</p>
            </div>
          </div>
          <form [formGroup]="createForm" (ngSubmit)="onCreateSetting()" class="create-form">
            <div class="form-fields">
              <mat-form-field appearance="outline">
                <mat-label>Plan</mat-label>
                <mat-select formControlName="planName" (selectionChange)="onPlanChange()">
                  <mat-option *ngFor="let plan of availablePlans" [value]="plan">
                    {{ planDisplayNames[plan] }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Feature</mat-label>
                <mat-select formControlName="feature">
                  <mat-option *ngFor="let feat of filteredFeatures" [value]="feat">
                    {{ feat }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Usage Limit</mat-label>
                <input matInput type="number" formControlName="usageLimit" min="1" />
              </mat-form-field>
              <div class="toggle-field">
                <label>Active</label>
                <mat-slide-toggle formControlName="isActive" color="primary"></mat-slide-toggle>
              </div>
            </div>
            <div class="form-actions">
              <button class="cmn-add-btn" type="submit"
                [disabled]="createForm.invalid || creatingInProgress">
                <mat-icon>add</mat-icon>
                {{ creatingInProgress ? 'Creating...' : 'Create Setting' }}
              </button>
            </div>
          </form>
        </div>
      </div>
      </ng-container>

      <!-- Settings grouped by plan -->
      <div class="plan-cards-wrapper" *ngIf="settings.length > 0">
        <div class="plan-card" [ngClass]="'plan-card-' + plan.toLowerCase()" *ngFor="let plan of plans">
          <ng-container *ngIf="getSettingsForPlan(plan).length > 0">
            <div class="plan-card-header">
              <div class="plan-title-row">
                <div class="plan-info">
                  <h4>{{ planDisplayNames[plan] }}</h4>
                  <span class="feature-count">{{ getSettingsForPlan(plan).length }} of {{ maxFeaturesPerPlan }} features configured</span>
                </div>
              </div>
            </div>
            <div class="plan-card-body">
              <div class="feature-row" *ngFor="let setting of getSettingsForPlan(plan); let last = last" [class.last-row]="last">
                <div class="feature-info">
                  <div class="feature-name">
                    <span>{{ setting.feature }}</span>
                  </div>
                </div>
                <div class="feature-limit">
                  <ng-container *ngIf="editingSettingId !== setting.id">
                    <div class="limit-display">
                      <span class="limit-value">{{ setting.usageLimit }}</span>
                      <span class="limit-label">uses</span>
                    </div>
                    <button *appHasPermission="'UPDATE_SETTINGS'" class="action-icon edit-btn" (click)="startEditLimit(setting)" [disabled]="updatingLimit">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </ng-container>
                  <ng-container *ngIf="editingSettingId === setting.id">
                    <div class="edit-limit">
                      <mat-form-field appearance="outline" class="limit-input">
                        <mat-label>Limit</mat-label>
                        <input matInput type="number" [(ngModel)]="editLimitValue" min="1" />
                      </mat-form-field>
                      <button class="action-icon save-btn" (click)="saveLimit(setting)" [disabled]="updatingLimit">
                        <mat-icon>check</mat-icon>
                      </button>
                      <button class="action-icon cancel-btn" (click)="cancelEditLimit()">
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                  </ng-container>
                </div>
                <div class="feature-status">
                  <mat-slide-toggle [checked]="setting.isActive" (change)="toggleActive(setting)"
                    [disabled]="updatingToggle" color="primary">
                  </mat-slide-toggle>
                  <span class="status-text" [class.active]="setting.isActive">
                    {{ setting.isActive ? 'Active' : 'Inactive' }}
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <app-content-loader [visible]="loading"></app-content-loader>
</section>
